module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAJCAYAAAALpr0TAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEDSURBVChTY0ABzMzGLA5W/0CYgYlJCyoKBoxQmoGBiVmfxc7iPAPDfwj/P+P/P4eOqTD8/38fIgACjIyycJMYGFiBAiIIPqMIRBHQCiRFDMzS8ouZJGVmAZmsEHHrfyCDGFnsrf8yMP5n/HPgGBOznOIKRiWJcJCGfzcezfj34mkm3ABGHkG/v+fO+wEVTQYqCv3/8fddxt//vzJKCzoz/mZW+Xv9RjaziLgXSDEDs7zyWhYHy/8spmZPwQJAwGph8QokBnIKiM/IrKK+k1FGyI3h85/Hf86elgOrggJWM7Pn/7mYJf7fe7GKEeRYxu9/Xv0+eVICKo8CWC3MX//nYBYGAHROWIyLO9aMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/default/top_arrow1.png
// module id = mULS
// module chunks = 1